<template>
  <div class="artwork-history-empty-state">
    <UseSvg class="artwork-history-empty-state__icon" :icon="icon" />
    <span> {{ emptyStateText }} </span>
  </div>
</template>

<script>
import UseSvg from "common/vue/components/UseSvg.vue";

export default {
  name: "ArtworkHistoryModalEmptyState",
  components: { UseSvg },
  props: {
    isLoading: {
      required: true,
      type: Boolean
    },
    isUploadedState: {
      required: false,
      type: Boolean,
      default: false
    },
    isMade: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    emptyStateText() {
      if (this.isLoading) return "Loading...";
      if (this.isMade) return "No designs found.";
      if (this.isUploadedState) return "Previous transfers uploads will show here.";
      return "Previous transfers purchases will show here.";
    },
    icon() {
      if (this.isUploadedState) return "upload-cloud";
      return "rebrand-carts";
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.artwork-history-empty-state {
  font-family: inherit;
  font-weight: 600;
  color: $app-gray-modern-700;
  padding: 20px;
  font-size: 16px;
  line-height: 22px;
  height: 300px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-height: 768px;

  @include with-tablet {
    height: calc(100vh - 430px);
  }

  &__icon {
    width: 80px;
    height: 80px;
    color: $app-gray-modern-300;
  }
}
</style>
